import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ImportValidationGroup } from "../../../core/utils/import-validation-error.util";

@Component({
  selector: "app-import-validation-error-panel",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./import-validation-error-panel.component.html",
  styleUrl: "./import-validation-error-panel.component.scss",
})
export class ImportValidationErrorPanelComponent {
  @Input() groups: ImportValidationGroup[] = [];
  @Input() summary = "";
  @Input() duplicateNote = "";

  trackByTestCaseId(_index: number, group: ImportValidationGroup): string {
    return group.testCaseId;
  }

  trackByLabel(_index: number, label: string): string {
    return label;
  }
}
